// src/components/auth/AuthRedirectHandler.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getGoogleRedirectResult } from '../../services/auth';

const AuthRedirectHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleRedirectResult = async () => {
      try {
        const result = await getGoogleRedirectResult();
        
        if (result) {
          console.log('Received redirect result:', result);
          
          if (result.isNewUser) {
            // New user - redirect to user type selection
            navigate('/auth/select-user-type', { 
              state: { uid: result.user.uid } 
            });
          } else if (result.userType) {
            // Existing user - navigate to spotlight page first
            navigate('/spotlight');
          } else {
            // Default fallback
            navigate('/spotlight');
          }
        }
      } catch (error) {
        console.error('Error handling redirect result:', error);
        // Optionally show an error message to the user
      }
    };

    handleRedirectResult();
  }, [navigate]);

  // This component doesn't render anything
  return null;
};

export default AuthRedirectHandler;